// @flow
import React, { Component } from 'react';
import {
  DesktopHeaderDiv,
  NavItemsDiv,
  HeaderSpacerDiv,
  LogoutDiv,
  LogoutTooltip
} from './DesktopHeaderStyles';
import PageTitle from '../PageTitle';
import HeaderNavItem from './HeaderNavItem';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  logout: () => void,
  currentRoute: string
};

export default class DesktopHeader extends Component<Props> {
  render() {
    return (
      <DesktopHeaderDiv>
        <PageTitle />
        <NavItemsDiv>
          <HeaderNavItem label="account" to="/account" icon="account" />
          <HeaderNavItem
            label="marketing"
            to="/marketing/sales-materials"
            isActive={() => this.props.currentRoute.startsWith('/marketing')}
            icon="doc"
          />
          <HeaderNavItem
            label="support"
            to="/support"
            isActive={() => this.props.currentRoute.startsWith('/support')}
            icon="questionmark"
          />
          <HeaderSpacerDiv />
          <LogoutDiv onClick={this.props.logout}>
            <DefaultIcon name="logout" />
            <LogoutTooltip message="Logout" direction="down" />
          </LogoutDiv>
        </NavItemsDiv>
      </DesktopHeaderDiv>
    );
  }
}
